import {ChangeDetectionStrategy, Component, Input} from "@angular/core";

@Component({
  selector: "n-control",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: [
    "./n-control.css"
  ],
  template: `
    <div class="n-control">
      <div class="n-control__label" *ngIf="label">{{label}}<span class="n-control__hint" [class._adaptive]="adaptiveHint" *ngIf="hint">{{hint}}</span></div>
      <div class="n-control__body">
        <ng-content></ng-content>
      </div>
      <div class="n-control__description" *ngIf="description">{{description}}</div>
    </div>
  `
})
export class NControlComponent {
  @Input() label: string;
  @Input() hint: string;
  @Input() description: string;
  @Input() adaptiveHint = true;
}
